import { defineStore } from 'pinia';
import { useStorage } from '@vueuse/core';
import { type IWaitingParsedResponse } from '@/services/ChallengeService';
interface IServiceOrder {
  dashboard: {
    dateRange: string
  }
}

interface IApp {
  wrResponse: IWaitingParsedResponse;
}

export const AppStore = defineStore('app', {
  state: () => ({
    app: useStorage('app', {
      wrResponse: {} as IWaitingParsedResponse,
    } as IApp),
  }),
  actions: {
    setWRResponse(response: IWaitingParsedResponse) {
      this.app.wrResponse = response;
    },
  },
  getters: {},
});
